import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal"; 
import { Context } from "../contexts/AppContext";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../lib/utils";
import NewFolderCreateP from "../PropertyList/NewFolderCreateP";

function NewFolderModal() {
 
 const { value } = useContext(Context);

 const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
 useEffect(() => {
   setModalOpen(appState.modalData); // modalOpen को अपडेट करें
 }, [appState.modalData]);
  
 
  
  const [folderName, setFolderName] = useState("");

  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "300px",
      height: "auto",
      width: "100%",
      overflow: "hidden",
      border:"1px solid #00bcd4",
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

  const closeModal = () => {
    console.log("CLOSE MODAL11111")
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 
  }

  const handleSubmit = async () => {
    if (!folderName.trim()) return; // Avoid empty folder names
   

    const response = await postData("folder/folders", { name: folderName });

    if (response) {
       
      setAppState((prevState) => ({ ...prevState, currentFolderName: folderName ,
        currentDBFolderId: response._id,
        currentFolderId:0,
        modalData:{ ...prevState.modalData, type: null, isOpen: false, folderUpdate: true}}
      ));
      const _appState = { 
       
         
        currentFolderId:0, 
    };
    console.log("_________APP___ ",_appState)
    localStorage.setItem('appState', JSON.stringify(_appState));
      
      closeModal();
    }
  };
 
  return (
    <Modal
      isOpen={modalOpen.isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="New Folder Modal"
    >
      <NewFolderCreateP updateData={setFolderName} />

      <div className="w-full flex justify-around mt-10 text-center">
        <button
          onClick={closeModal}
          type="button"
          className="text-white  bg-[#854d0e] font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          type="button"
          className="text-white  bg-[#854d0e] font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Submit
        </button>
      </div>
    </Modal>
  );
}

export default NewFolderModal;
